import { Divider, Flex, Box, Text } from '@cad-arc';
import { CloseMapLedgerAndClearSelectedEntityButton } from '../close-map-ledger-and-clear-selected-entity-button';
import hospitalInactive from '../../../../esri/images/hospital-icons/hospital_inactive.svg';
import { FR_ICON_SIZE, ICON_SIZE } from '../constants';
import { CommonSize } from '../../../../common/helpers/utils';

type HospitalOverviewProps = {
    hospitalName: string;
    size: CommonSize;
};

export function HospitalOverview({
    hospitalName,
    size,
}: HospitalOverviewProps): React.ReactElement {
    const iconSize = size === 'lg' ? FR_ICON_SIZE : ICON_SIZE;

    return (
        <Box data-testid="MAP_HOSPITAL_OVERVIEW_SECTION">
            <Flex alignItems="center" justifyContent="space-between" padding="12px 18px">
                <Flex alignItems="center" gap={1}>
                    <Flex alignItems="center" width={iconSize} minWidth={iconSize}>
                        <img src={hospitalInactive} alt="icon" data-testid="MAP_HOSPITAL_ICON" />
                    </Flex>
                    <Text fontWeight="bold" fontSize={size} style={{ wordBreak: 'break-word' }}>
                        {hospitalName}
                    </Text>
                </Flex>
                <CloseMapLedgerAndClearSelectedEntityButton />
            </Flex>
            <Divider />
        </Box>
    );
}
